'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _ = require('lodash');

var e = ['INCOMPLETE', 'PROPOSAL', 'REQUEST', 'CANCELLED_REQUEST_GUEST', 'ACCEPTED_GUEST', 'ACCEPTED_HOST', 'COUNTEROFFER', 'DECLINED_HOST', 'DECLINED_GUEST', 'PRE_DEPOSIT_ALTERATION', 'DEPOSIT', 'CANCELLED_POST_DEPOSIT_CLIENT', 'CANCELLED_POST_DEPOSIT_VENUE', 'POST_DEPOSIT_ALTERATION', 'ALTERATION_ACCEPTED_GUEST', 'ALTERATION_ACCEPTED_HOST', 'PAID', 'CONCLUDED', 'RECONCILED', 'CLOSED', 'EXPIRED'];

/**
 * Active states are those where something can still happen to the request. For instance, once a request has been
 * `CLOSED`, it is no longer active. Once it has been declined, it is also no longer active. We should also not include `INCOMPLETE`
 */
e.activeStates = ['PROPOSAL', 'REQUEST', 'ACCEPTED_GUEST', 'ACCEPTED_HOST', 'COUNTEROFFER', 'DEPOSIT', 'PRE_DEPOSIT_ALTERATION', 'POST_DEPOSIT_ALTERATION', 'ALTERATION_ACCEPTED_GUEST', 'ALTERATION_ACCEPTED_HOST', 'PAID', 'CONCLUDED', 'RECONCILED'];

e.preBookedStates = ['INCOMPLETE', 'PROPOSAL', 'REQUEST', 'COUNTEROFFER', 'ACCEPTED_HOST', 'ACCEPTED_GUEST', 'PRE_DEPOSIT_ALTERATION', 'DECLINED_HOST', 'DECLINED_GUEST', 'CANCELLED_REQUEST_GUEST', 'EXPIRED'];

e.cancelledStates = ['CANCELLED_REQUEST_GUEST', 'CANCELLED_POST_DEPOSIT_CLIENT', 'CANCELLED_POST_DEPOSIT_VENUE', 'DECLINED_HOST', 'DECLINED_GUEST', 'EXPIRED'];

e.cancelledPostDepositStates = ['CANCELLED_POST_DEPOSIT_CLIENT', 'CANCELLED_POST_DEPOSIT_VENUE'];

e.outstandingStates = _.without.apply(_, [e.preBookedStates].concat(_toConsumableArray(e.cancelledStates)));

e.pendingRequestState = ['PROPOSAL', 'COUNTEROFFER', 'REQUEST'];

e.acceptedRequestState = ['ACCEPTED_HOST', 'ACCEPTED_GUEST', 'ALTERATION_ACCEPTED_GUEST', 'ALTERATION_ACCEPTED_HOST'];

e.depositPendingRequestState = ['ACCEPTED_HOST', 'ACCEPTED_GUEST', 'PRE_DEPOSIT_ALTERATION'];

e.hostCanCounteroffer = _.without(e, 'CANCELLED_REQUEST_GUEST', 'DECLINED_GUEST', 'DECLINED_HOST', 'CONCLUDED', 'RECONCILED', 'CLOSED');

e.adminCanCounteroffer = e.hostCanCounteroffer.concat(['CONCLUDED']);

e.alterationRequestState = ['PRE_DEPOSIT_ALTERATION', 'POST_DEPOSIT_ALTERATION'];

/**
 * counter offer states
 * INIT - host has begun drafting a counteroffer
 * READY - guest can accept counteroffer and apply deltas
 * REMOVED - counteroffer was removed
 * DECLINED - guest declined counteroffer
 * ACCEPTED - guest has accepted counteroffer
 */
e.counterofferState = ['INIT', 'READY', 'REMOVED', 'DECLINED', 'ACCEPTED'];

e.postPaymentStates = ['CONCLUDED', 'RECONCILED', 'CLOSED'];

e.bookedStates = ['DEPOSIT', 'PAID'].concat(['POST_DEPOSIT_ALTERATION', 'ALTERATION_ACCEPTED_GUEST', 'ALTERATION_ACCEPTED_HOST'], e.postPaymentStates);

e.cancellableStates = _.without.apply(_, [e.bookedStates].concat(_toConsumableArray(e.postPaymentStates)));

e.paidStates = e.bookedStates.concat(['CANCELLED_POST_DEPOSIT_CLIENT', 'CANCELLED_POST_DEPOSIT_VENUE']);

e.sentProposalStates = _.without(e, 'INCOMPLETE', 'PROPOSAL');

e.activeProposalStates = ['ACCEPTED_HOST', 'ACCEPTED_GUEST', 'PROPOSAL', 'REQUEST', 'COUNTEROFFER'];

e.killedArchived = ['Event Cancelled', 'Event Postponed'];

e.activeSentProposalStates = _.without.apply(_, [e.sentProposalStates].concat(_toConsumableArray(e.cancelledStates)));

e.refundStates = ['DEPOSIT', 'POST_DEPOSIT_ALTERATION', 'ALTERATION_ACCEPTED_GUEST', 'ALTERATION_ACCEPTED_HOST', 'PAID', 'CONCLUDED'];

e.preBalanceAndPostDepositStates = ['DEPOSIT', 'POST_DEPOSIT_ALTERATION', 'ALTERATION_ACCEPTED_GUEST', 'ALTERATION_ACCEPTED_HOST'];

module.exports = e;